import React from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
} from '../ui/dropdown-menu';
import { Button } from '../ui/button';
import { Settings } from 'lucide-react';

export type CountMode = 'sessions' | 'users' | 'total';

interface AdvancedSettingsProps {
  countMode: CountMode;
  onCountModeChange: (mode: CountMode) => void;
}

export default function AdvancedSettings({
  countMode,
  onCountModeChange,
}: AdvancedSettingsProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="icon">
          <Settings className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel>Display Settings</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuLabel className="text-xs text-gray-500 font-normal">
          Count by
        </DropdownMenuLabel>
        <DropdownMenuRadioGroup
          value={countMode}
          onValueChange={(v) => onCountModeChange(v as CountMode)}
        >
          <DropdownMenuRadioItem value="sessions">
            Sessions
            <span className="ml-auto text-xs text-gray-400">Unique sessions</span>
          </DropdownMenuRadioItem>
          <DropdownMenuRadioItem value="users">
            Users
            <span className="ml-auto text-xs text-gray-400">Unique users</span>
          </DropdownMenuRadioItem>
          <DropdownMenuRadioItem value="total">
            Total
            <span className="ml-auto text-xs text-gray-400">All transitions</span>
          </DropdownMenuRadioItem>
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
